'use strict';

angular.module('app.error')
    .factory('ErrorMessages', ['gettextCatalog', 'gettext', 'ShareCrfApiErrorCodes', '$log', function(gettextCatalog, gettext, ShareCrfApiErrorCodes, $log) {
        var _errorCodes = {
            // RouteError
            'authentication-required': gettext('Para acceder a la página solicitada debe iniciar sesión en ShareCRF'),
            'permission-required': gettext('No cuenta con los permisos suficientes para acceder a la página solicitada'),
            'successful-logout': gettext('Se ha cerrado la sesión. Identifíquese para acceder de nuevo a la aplicación'),
            'password-changed': gettext('Su clave de acceso se actualizado de manera satisfactoria. Ahora puede iniciar sesión con su nueva contraseña.'),
            'missing-invitation': gettext('La invitación ha caducado o fue borrada. Por favor, póngase en contacto con el coordinador del su estudio para solicitar una nueva invitación al mismo.'),
            'session-expired': gettext('Su sesión ha caducado porque ha transcurrido demasiado tiempo sin actividad.\nPor favor, identifíquese de nuevo para acceder a la aplicación.'),

            // General
            'form-errors': gettext('El formulario contiene errores'),
        };

        return {
            /**
             * Obtiene el mensaje legible para el error que se le pasa.
             * Puede ser una instancia de Error (p.ej. API) o un código en formato de string directamente
             *
             * @param  {Error|string} error Error o código del mensaje
             *
             * @return {string}       Mensaje de texto legible
             */
            get: function(error) {
                var message;
                if (error instanceof Error) {
                    if (error.message === 'api-error') {
                        message = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                        $log.debug('Message and error parameters', message, error.info);
                        message = gettextCatalog.getString(message, error.info);
                    } else {
                        // Error nativo Javascript, puede ser controlado o no
                        if (error.code) {
                            // Si tiene una propiedad code, es que lo hemos modificado nosotros para emparejarlo
                            // con un error conocido
                            message = _errorCodes[error.code];
                        }
                    }
                } else if (typeof error === 'string') {
                    message = _errorCodes[error];
                }

                if (!message) {
                    $log.error('Error code not recognized by ErrorMessages', error);
                    message = gettext('Se ha producido un error inesperado');
                }

                return message;
            },
        };
    }]);
